import { isMobile } from './isMobile';

const tabletBreakpoint = 960;

export const isTablet = () => {
    const maxInner = Math.max(window.innerHeight, window.innerWidth);
    return isMobile() && maxInner > tabletBreakpoint;
};
